import {
  DataGridPro as DataGrid,
  DataGridProProps,
  GridColumnHeaderParams,
  GridColumns,
  GridLinkOperator,
  GridOverlay,
  GridRowModel,
  useGridApiRef,
  GridSortModel,
} from '@mui/x-data-grid-pro';
import { useSelector } from 'store/hooks';
import { selectedWorkunitDatagridColumnsParams } from './service/selectedWorkunitDatagridColumnsService';
import SelectedWorkunitDatagridColumns from './SelectedWorkunitDatagridColumns';
import useOrderWorkunitsService from 'features/Orders/OrderWorkunits/services/useOrderWorkunitsService';
import { Box, Dialog, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { SelectedWorkunit } from 'types/entities/SelectedWorkunit';
// import EditTotalWorkunit from '../../EditTotalWorkunit/EditTotalWorkunit';
import React, { useEffect, useState } from 'react';
import Scope from 'types/entities/Scope';
import { openDialogAction } from 'store/actions/dialogsActions';
import { useAppState } from 'store/Provider';
import {
  filterTotalFlagAction,
  injectFilterTotalWorkunitsBLAction,
  injectTotalWorkunitsBLAction,
  selectBLDeliverablesAction,
} from 'store/actions/changeBaselineActions';

type SelectedWorkunitsDataGridProps = {
  selectedWorkunitsFilter: SelectedWorkunit[];
  setCurrentStep: React.Dispatch<React.SetStateAction<any>>;
  handleSubmitNewbaseLine: any;
};

const SelectedWorkunitsDataGrid = (props: SelectedWorkunitsDataGridProps) => {
  const [t] = useTranslation();
  // const initialWorkunits = useSelector((state) => state.catalogToOrder.initialWorkunits);
  // const selectedWorkunitsFilter = useSelector((state) => state.catalogToOrder.selectedWorkunitsFilter);
  // const scopes = useSelector((state) => state.catalogToOrder.scopes);
  const { dispatch } = useAppState();
  const { selectedWorkunitsFilter, setCurrentStep, handleSubmitNewbaseLine } = props;
  const activeEditRows = useSelector((state) => state.catalogToOrder.selectedWorkunitsEditIds);
  const searchFilter = useSelector((state) => state.catalogToOrder.orderHandler.searchParams);
  const selectedScope: number | null = useSelector(
    (state) => (state.catalogToOrder.orderHandler.searchParams?.scope as number) ?? null
  );
  const [sortModel, setSortModel] = useState<GridSortModel>([]);
  const [workunitFilter, setWorkunitFilter] = useState<SelectedWorkunit[] | undefined>(selectedWorkunitsFilter);

  const handleHeaderClick = (params: GridColumnHeaderParams) => {
    console.log(`Header for column '${params.field}' clicked!`);

    if (params.field === 'total') {
      handleSubmitNewbaseLine('worunitadd');
      setTimeout(() => {
        dispatch(selectBLDeliverablesAction([]));
        dispatch(injectFilterTotalWorkunitsBLAction({ datas: [] }));
        dispatch(injectTotalWorkunitsBLAction({ datas: [], totalItems: 0, totalPages: 0, currentPage: 0 }));
        dispatch(openDialogAction({ name: 'changeBaselinetotalWorkunitDialog' }));
        dispatch(filterTotalFlagAction(true));
      }, 300);

      // 1. Update state to indicate that the dialog should be shown
      // setCurrentStep(5);
    }
  };

  useEffect(() => {
    setWorkunitFilter(selectedWorkunitsFilter);
    // setApifunctionFlag(false);
  }, [selectedWorkunitsFilter]);

  const { updateSelectedWorkunit } = useOrderWorkunitsService();

  const processRowUpdate = React.useCallback(
    async (newRow: GridRowModel, oldRow: GridRowModel) => {
      updateSelectedWorkunit(newRow);
      return newRow;
    },
    [updateSelectedWorkunit]
  );

  const apiRef = useGridApiRef();
  const handleProcessRowUpdateError = React.useCallback((error: Error) => {
    console.log(error);
  }, []);
  // const getValue = (obj: any, path: string): any => path.split('.').reduce((acc, key) => acc?.[key], obj);
  const getValue = (obj: any, path: string): any => path.split('.').reduce((acc, key) => acc?.[key], obj);
  const handleSortModelChange = (model: GridSortModel) => {
    setSortModel(model);

    if (model.length === 0) {
      setWorkunitFilter(workunitFilter); // Reset
      return;
    }

    const { field, sort } = model[0];

    const sorted = [...workunitFilter].sort((a, b) => {
      const aValue = getValue(a, field);
      const bValue = getValue(b, field);

      if (typeof aValue === 'string' && typeof bValue === 'string') {
        return sort === 'asc' ? aValue.localeCompare(bValue) : bValue.localeCompare(aValue);
      }

      return sort === 'asc' ? (aValue ?? 0) - (bValue ?? 0) : (bValue ?? 0) - (aValue ?? 0);
    });

    setWorkunitFilter(sorted);
  };

  const selectedWorkunitColumns = () =>
    SelectedWorkunitDatagridColumns({ columnsDef: selectedWorkunitDatagridColumnsParams, apiRef });

  return (
    <>
      <Box sx={{ height: '420px', mb: 4 }}>
        <DataGrid
          rows={workunitFilter}
          columns={selectedWorkunitColumns() as GridColumns}
          checkboxSelection={false}
          disableSelectionOnClick
          disableColumnFilter
          disableColumnSelector
          disableColumnMenu
          hideFooter
          headerHeight={70}
          rowHeight={70}
          apiRef={apiRef}
          // onSortModelChange={handleSortModelChange}
          // experimentalFeatures={{ newEditingApi: true }}
          disableColumnReorder
          editMode="cell"
          isCellEditable={(params) => activeEditRows.includes(params.row.randomId)}
          getRowId={(row) => {
            if (!row) throw new Error('Row is undefined');
            return row.randomId;
          }}
          // filterModel={{
          //   items: [
          //     { id: 1, columnField: 'reference', operatorValue: 'contains', value: searchFilter?.reference },
          //     { id: 2, columnField: 'name', operatorValue: 'contains', value: searchFilter?.name },
          //     { id: 3, columnField: 'scope', operatorValue: 'isSame', value: selectedScope || 0 },
          //   ],
          //   linkOperator: GridLinkOperator.And,
          // }}
          components={{
            NoRowsOverlay: () => (
              <GridOverlay>
                <Typography variant="h6" color="primary.main">
                  {t('select_wu_catalog')}
                </Typography>
              </GridOverlay>
            ),
          }}
          sortModel={sortModel}
          onSortModelChange={handleSortModelChange}
          processRowUpdate={processRowUpdate}
          /*         onCellEditStop={(params: GridCellEditStopParams, event: MuiEvent) => {
          if (params.reason === GridCellEditStopReasons.cellFocusOut) {
            // eslint-disable-next-line no-param-reassign
            event.defaultMuiPrevented = true;
          }
        }} */
          onProcessRowUpdateError={handleProcessRowUpdateError}
          onColumnHeaderClick={handleHeaderClick}
          sx={{
            '& .MuiDataGrid-columnSeparator': {
              display: 'none',
            },
            overflow: 'auto',
          }}
          getRowClassName={(params) => (params.indexRelativeToCurrentPage % 2 === 0 ? 'Mui-even' : 'Mui-odd')}
        />
      </Box>
    </>
  );
};
export default SelectedWorkunitsDataGrid;
